<template>
  <div class="full-height">
    <crud-layout-search
      ref="crudLayoutSearch"
      :name="name"
      :interface="nmInterface"
      :id="id"
      :page-detail="detailPage"
    />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import IndustrialIntegrationErrorDetail from './IndustrialIntegrationErrorDetail.vue'

const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'IndustrialIntegrationError',
  components: { CrudLayoutSearch, IndustrialIntegrationErrorDetail },
  props: {
    name: String,
    id: String
  }
})
class IndustrialIntegrationError extends Vue {
  nmInterface = 'industrialIntegrationError.pesquisar'

  get detailPage () {
    return IndustrialIntegrationErrorDetail
  }
}

export default IndustrialIntegrationError
</script>
